'use client';

import React from 'react';
import ReviewsSlider from '@/components/shared/ReviewsSlider';

/**
 * Figma desktop 303:3424 / mobile 303:3031 — the section is an empty placeholder in the
 * design (three blank cards), so the content is the live homepage's five reviews, shown
 * through the existing ReviewsSlider (3-up on desktop, swipeable on mobile).
 */
const REVIEWS = [
  {
    img: '/images/comix/homepage/review/review_4.png',
    review:
      '"My son walked around the house all day showing everyone \'his book.\' He was SO proud. The look on his face was worth every penny."',
    name: '– Tom P., James\' dad',
  },
  {
    img: '/images/comix/homepage/review/review_1.png',
    review:
      '"I honestly didn\'t expect it to look this good. It captured exactly how chaotic my life is — and made it hilarious. Best thing I\'ve ever bought myself."',
    name: '– Aaliyah R.',
  },
  {
    img: '/images/comix/homepage/review/review_2.png',
    review:
      '"I made one starring my dog Biscuit and now he sits next to it like he knows he\'s famous. I think he does. 10/10 would recommend."',
    name: '– Karen W., Biscuit\'s mom',
  },
  {
    img: '/images/comix/homepage/review/review_3.png',
    review:
      '"Made one about our friend group and the eternal debate of where to eat. It\'s 100% accurate and now everyone wants their own copy."',
    name: '– Marco D.',
  },
  {
    img: '/images/comix/homepage/review/review_5.png',
    review:
      '"My daughter wouldn\'t put it down for two hours. She finally has a superhero who looks just like her — red hair and all. She keeps rereading it."',
    name: '– Sarah L., Emma\'s mom',
  },
];

export default function Community() {
  return (
    // Top padding is dropped — How It Works already supplies the gap-6 (24px) boundary
    // via its own trimmed bottom padding, matching the gap between its step cards.
    <section className="w-full pb-[var(--hp-section-y)]">
      <div className="hp-container">
        <h2
          className="text-center font-bold tracking-[-0.454px] text-[var(--hp-ink)]"
          style={{ fontSize: 'var(--hp-h2)', lineHeight: 1.35 }}
        >
          Join our community
        </h2>
      </div>

      {/* Mobile bleeds so slides peek; desktop snaps back to the 1040 grid, matching
          How It Works' top spacing (mt-8 / dt:mt-10) so the two sections line up. */}
      <div className="hp-reviews mt-8 dt:mt-10">
        <ReviewsSlider reviews={REVIEWS} edgeArrows />
      </div>
    </section>
  );
}
